import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/朱雀";
import { Soulmark } from "../../core/soulmark";
import { Skin } from "../../core/skin";

export class 朱雀 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(3318, "炽羽炎凰·朱雀", type.飞行·火, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "1. 每回合开始时自身速度+2，自身速度等级每提升2级，所有技能先制便会额外+1；自身处于速度能力提升状态时，直接攻击必定致命一击；自身速度能力提升状态被消除时有50%的几率令对手焚烬，未触发则100%令对手烧伤。",
            "2. 受到致死攻击时有一次机会触发<span style='color: #ed3333; font-weight: bold;'>凤之涅槃</span>：解除自身所有异常状态和能力下降，恢复自身全部体力和技能pp值，并且可以抵挡2次攻击伤害。",
            "3. 每当自身脱离异常状态时，恢复最大体力的1/1并对对手造成等量的固定伤害；每当对手脱离异常状态时，吸取对手最大体力的1/3。",
        ]);
        this.技能组 = [
            skill.业火红莲,
            skill.永生之池,
            skill.九霄凤鸣,
            skill.青鸾炽羽阵,
            skill.凤仪九州城
        ];
        this.皮肤组.push(new Skin(2676, "炽凰·朱雀"));
        this.皮肤组.push(new Skin(504, "菲尼克斯"));
    }
}
